<template>
  <v-img
    :src="apiURL + 'organism/' + id + '/picture'"
    contain
    :height="height"
    class="white"
  />
</template>

<script>
import api from "../../api.js";
export default {
  props: {
    id: {
      type: String
    },
    height: {
      type: Number,
      default: 150
    }
  },
  data: () => ({
    apiURL: api.baseURL
  })
};
</script>

<style></style>
